module.exports = __webpack_public_path__ + "img/Bedroom.a12c98d0.jpg";